import React from "react";

function Draft() {
  return (
    <div className="container">
      <h1 className="text-danger">Draft page here </h1>
 
     
    </div>
  );
}

export default Draft;
